import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import classnames from 'classnames';
import loc from 'Components/languages';
import { convertFloatToPrice, isValidInvoiceNo } from 'Helpers/helpers';
import InputText from 'Components/input-text';
import PaymentDetailField from './PaymentDetailField.jsx';
import PaymentDetailEntry from './PaymentDetailEntry.jsx';
import ExchangeRateBox from './ExchangeRateBox.jsx';
import styles from './PaymentDetails.less';

class PaymentDetails extends PureComponent {
	constructor() {
		super();
		this.state = {
			invNo: '',
		};
		this.isQOrder = this.isQOrder.bind(this);
		this.onSubmitHandler = this.onSubmitHandler.bind(this);
		this.onChangeInvNoHandler = this.onChangeInvNoHandler.bind(this);
		this.onBlurInvNoHandler = this.onBlurInvNoHandler.bind(this);
		this.onKeyDownInvNoHandler = this.onKeyDownInvNoHandler.bind(this);
	}

	componentDidMount() {
		this.setState({
			invNo: this.props.salesOrder.get('inv_no'),
		});
	}

	isQOrder() {
		const { salesOrder } = this.props;
		return salesOrder.get('doc_type') === 'DP1';
	}

	onSubmitHandler(e) {
		e.preventDefault();
	}

	onChangeInvNoHandler(e) {
		this.setState({
			invNo: e.target.value.toUpperCase(),
		});
	}

	onBlurInvNoHandler() {
		const { invNo } = this.state;
		this.props.onChangeInvoiceNo(invNo);
	}

	onKeyDownInvNoHandler(e) {
		if (e.key === 'Enter') {
			e.target.blur();
			this.onBlurInvNoHandler();
		}
	}

	render() {
		const { invNo } = this.state;
		const { salesOrder, paymentMethods, onFocusDepositAmount, onChangeTransactionPayment, onRemoveTransactionPayment } = this.props;
		const isQOrder = this.isQOrder();
		return (
			<div className="payDetContainer uk-child-width-expand">
				<div className="uk-width-5-6">
					<form
						className="uk-form-horizontal"
						onSubmit={ this.onSubmitHandler }
						data-uk-height-viewport="offset-top: true; offset-bottom: 84px"
						data-uk-overflow-auto="selContainer: .stepContainer; selContent: .payDetContainer"
					>
						<h4 className="uk-text-uppercase">&nbsp;</h4>
						<div className={ classnames(styles.field, 'uk-flex uk-flex-middle') }>
							<div className="uk-width-2-5 uk-text-secondary uk-h5 uk-margin-remove uk-text-uppercase">
								{ loc.invoiceNo } :
							</div>
							<div className="uk-width-2-5 uk-text-bold">
								<InputText
									value={ invNo }
									placeholder="XX-YYYYYYYY"
									maxLength={ 11 }
									onChange={ this.onChangeInvNoHandler }
									onBlur={ this.onBlurInvNoHandler }
									onKeyDown={ this.onKeyDownInvNoHandler }
								/>
							</div>
							<div className="uk-width-1-5" />
						</div>
						{
							invNo && !isValidInvoiceNo(invNo) && (
								<div className={ classnames(styles.errorText, 'uk-text-danger', 'uk-text-small') }>
									{ loc.invoiceNoInvalid }
								</div>
							)
						}
						<PaymentDetailField
							label={ loc.orderType }
							value={ isQOrder ? 'Q' : 'R' }
						/>
						<PaymentDetailField
							label={ loc.netAmount }
							// label={ `${loc.netAmount} (${ loc.with }${ loc.consumptionTax })` }
							value={ convertFloatToPrice(salesOrder.get('net_amount')) }
						/>
						{/* {
							salesOrder.get('tax_rate') && (
								<PaymentDetailField
									label={ `${salesOrder.get('tax_rate') }% ${ loc.consumptionTax }` }
									value={ convertFloatToPrice(salesOrder.get('tax_amount')) }
								/>
							)
						} */}
						{
							isQOrder && (
								<PaymentDetailField
									label={ loc.depositTotal }
									value={ salesOrder.get('deposit_amount') }
									onClick={ onFocusDepositAmount }
								/>
							)
						}
						<PaymentDetailField
							label={ loc.paymentMethods }
							hideValue={ true }
						/>
						<div
							className="uk-flex uk-flex-column uk-flex-top uk-padding-small uk-padding-remove-horizontal"
						>
							{
								salesOrder.get('transaction_payments').map((transactionPayment, index) => (
									<PaymentDetailEntry
										key={ `payment-details-entry-${index}` }
										index={ index }
										code={ transactionPayment.get('pay_code') }
										icon={ paymentMethods.get(transactionPayment.get('pay_code')) && paymentMethods.get(transactionPayment.get('pay_code')).get('pay_icon') }
										amount={ transactionPayment.get('amount') }
										couponCode={ transactionPayment.get('coupon_code') }
										onChange={ onChangeTransactionPayment }
										onRemove={ onRemoveTransactionPayment }
									/>
								))
							}
						</div>
						<PaymentDetailField
							label={ loc.balanceDue }
							value={ convertFloatToPrice(salesOrder.get('remaining_amount')) }
						/>
						<PaymentDetailField
							label={ loc.paymentAmount }
							value={ convertFloatToPrice(salesOrder.get('payment_amount')) }
						/>
						<PaymentDetailField
							label={ loc.change }
							value={ convertFloatToPrice(salesOrder.get('change_amount')) }
						/>

						<div className={ styles.exchangeRateBox }>
							<ExchangeRateBox
								salesOrder={ salesOrder }
							/>
						</div>
					</form>
				</div>
			</div>
		);
	}
}

PaymentDetails.propTypes = {
	salesOrder: PropTypes.instanceOf(Map).isRequired,
	paymentMethods: PropTypes.instanceOf(Map).isRequired,
	onChangeInvoiceNo: PropTypes.func.isRequired,
	onFocusDepositAmount: PropTypes.func.isRequired,
	onChangeTransactionPayment: PropTypes.func.isRequired,
	onRemoveTransactionPayment: PropTypes.func.isRequired,
};

export default PaymentDetails;
